export default "__VITE_ASSET__qY9bNuRc__"